// extracted by mini-css-extract-plugin
export default {"root":"Header_root__Mtkc0","header":"Header_header__8ScmJ","inner":"Header_inner__CJ3sg","buttons":"Header_buttons__eZDW3","p":"Header_p__DoJGE","subp":"Header_subp__Zovzx"};